// Work package "projects": projects, setup, running-project import, Home and global pages.
// This folder belongs to the WP (docs/v3/WORKPACKAGES.md 4). Other areas may
// import what this file exports (read-only use); they never edit this folder.
// Every route of this WP (docs/v3/COVERAGE.md).
import { PAGES } from "@convenor/shared";
import { extra, moved, page, screen, type AreaRoute } from "../../routes/types";

export const routes: AreaRoute[] = [
  // 2. Projects and setup
  // Consortium partners have no organisation of their own and still see their projects here.
  screen(19, page(() => import("./pages/ProjectsPage"), "ProjectsPage"), { allowNoOrg: true }),
  // Onboarding (Task 1.1): one start for every project (boards A1, B1). It replaces
  // the old setup wizard's first step (#21, Task 3.5): its address starts a new project.
  screen([20, 21], page(() => import("./pages/onboarding/StartPage"), "StartPage")),
  moved("/projects/new/contract", PAGES.projectsNew),
  // Step 1 again for a project made by the old setup wizard (#22-#26 serve those projects).
  extra(PAGES.setupContract, page(() => import("./pages/SetupContractPage"), "SetupContractEditPage")),
  screen(22, page(() => import("./pages/SetupLogframePage"), "SetupLogframePage")),
  screen(23, page(() => import("./pages/SetupTeamPage"), "SetupTeamPage")),
  screen(24, page(() => import("./pages/SetupTorPage"), "SetupTorPage")),
  screen(25, page(() => import("./pages/SetupBrandingPage"), "SetupBrandingPage")),
  screen(26, page(() => import("./pages/SetupDonePage"), "SetupDonePage")),
  // Onboarding (Task 1.2): drop every document once (board A2); the old upload address starts a new project.
  screen(27, page(() => import("./pages/onboarding/DocumentsPage"), "DocumentsPage")),
  moved("/projects/import", PAGES.projectsNew),
  // Onboarding (Task 1.3): the files are read in the background, with live progress (board A3).
  screen(167, page(() => import("./pages/onboarding/ReadingPage"), "ReadingPage")),
  // Onboarding (Task 1.4): the review workspace, one page for every section (boards A4a-A4h).
  screen(168, page(() => import("./pages/onboarding/ReviewPage"), "ReviewPage")),
  // Onboarding (Task 3.1): the draft in short, what is open, who is invited, then Start project (board A5).
  screen(169, page(() => import("./pages/onboarding/ReadyPage"), "ReadyPage")),
  // Onboarding (Task 3.4): Settings › Project setup, the setup read-only and documents added after the start (board A6).
  screen(170, page(() => import("./pages/onboarding/ProjectSetupPage"), "ProjectSetupPage")),
  screen(28, page(() => import("./pages/OnboardReviewPage"), "OnboardReviewPage")),
  screen(29, page(() => import("./pages/OnboardConfirmPage"), "OnboardConfirmPage")),
  screen(30, page(() => import("./pages/OnboardGapsPage"), "OnboardGapsPage")),
  screen(31, page(() => import("./pages/OnboardCutoffPage"), "OnboardCutoffPage")),
  screen(32, page(() => import("./pages/OnboardDonePage"), "OnboardDonePage")),
  screen(33, page(() => import("./pages/OnboardCallPage"), "OnboardCallPage")),
  // 3. Home and global
  screen(34, page(() => import("./pages/HomePage"), "HomePage")),
  screen(35, page(() => import("./pages/SearchPage"), "SearchPage")),
  screen([36, 37], page(() => import("./pages/NotificationsPage"), "NotificationsPage")),
  screen(38, page(() => import("./pages/ActivityLogPage"), "ActivityLogPage")),
];
